let animationsZone3 = {

    animateHead: () => {

        // vars
        let iconHead1 = ".iconHead1",
            iconHead2 = ".iconHead2",
            manBody1 = ".manBody1",
            theFace = ".theFace",
            tl = new TimelineLite({
                onComplete: complete,
                onCompleteParams: ['{self}']
            });

        tl.to(iconHead1, 0.5, {
                scale: 0.8,
                transformOrigin: "center"
            })
            .to(iconHead2, 0.5, {
                scale: 0.8,
                transformOrigin: "center"
            }, "-=0.5")
            .to(iconHead1, 0.5, {
                x: 2,
                transformOrigin: "center"
            }).to(theFace, 1, {
                x: 4,
                scale: 0.8
            }, "-=0.5")
            .to(iconHead2, 0.5, {
                x: -2,
                transformOrigin: "center"
            }, "-=0.5")
            .to(manBody1, 0.5, {
                rotation: 5,
                transformOrigin: "center"
            }, "-=1.0")
            .to(iconHead1, 0.6, {
                x: 0,
                transformOrigin: "center"
            }, "+=1")
            .to(theFace, 1, {
                x: 0,
                scale: 1
            }, "-=0.6")
            .to(manBody1, 0.5, {
                rotation: 0,
                transformOrigin: "center"
            }, "-=1")
            .to(iconHead2, 0.6, {
                x: 0,
                transformOrigin: "center"
            }, "-=1")
            .to(iconHead1, 0.6, {
                x: -2,
                transformOrigin: "center"
            }, "+=1")
            .to(theFace, 1, {
                x: -3,
                scale: 0.8
            }, "-=0.6")
            .to(manBody1, 0.5, {
                rotation: -5,
                transformOrigin: "center"
            }, "-=1.1")
            .to(iconHead2, 0.6, {
                x: 2,
                transformOrigin: "center"
            }, "-=1")
            .to(iconHead1, 0.6, {
                x: 0,
                transformOrigin: "center"
            }, "+=1")
            .to(theFace, 1, {
                x: 0,
                scale: 1
            }, "-=0.6")
            .to(manBody1, 0.6, {
                rotation: 0,
                transformOrigin: "center"
            }, "-=1.1")
            .to(iconHead2, 0.6, {
                x: 0,
                transformOrigin: "center"
            }, "-=1")
            .to(iconHead1, 0.6, {
                scale: 1,
                transformOrigin: "center"
            }, "+=1")
            .to(iconHead2, 0.6, {
                scale: 1,
                transformOrigin: "center"
            }, "-=1");

        function complete(tl) {
            setTimeout(function() {
                tl.restart();
            }, 1000);
        }
    },

    animateBigCircle: () => {


        // vars
        let bigCircle = ".bigCircle",
            circleBg = ".circleBg",
            tl = new TimelineLite({
                onComplete: complete,
                onCompleteParams: ['{self}']
            });

        tl.to(bigCircle, 1, {
            y: 13
        }).
        to(bigCircle, 1, {
                y: 13
            })
            .to(circleBg, 1, {
                fill: "#AF4298"
            }, "-=2")
            .to(circleBg, 1, {
                fill: "#AF4298"
            })
            .to(bigCircle, 1, {
                y: 0
            })
            .to(circleBg, 1, {
                fill: "#E63A66"
            }, "-=1");

        function complete(tl) {
            setTimeout(function() {
                tl.restart();
            }, 4000);
        }

    }
};

$(document).ready([animationsZone3.animateHead, animationsZone3.animateBigCircle]);
